module.exports = __webpack_public_path__ + "img/back.48f2dc1e.svg";